require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/fn/regexp/escape.js
// module id = ./node_modules/babel-polyfill/node_modules/core-js/fn/regexp/escape.js
// module chunks = 4